import React from 'react';

export const yuan = v => `¥${Number(v || 0).toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
export const qtyText = v => Number(v || 0).toLocaleString();
export const priceText = v => (v === null || v === undefined ? '-' : Number(v).toFixed(4));
export const percentText = v => `${Number(v || 0).toFixed(2)}%`;

export const materialColumns = [
  { title: '物料编码', dataIndex: 'materialNumber', key: 'materialNumber', width: 110, fixed: 'left' },
  { title: '物料名称', dataIndex: 'materialName', key: 'materialName', width: 220, ellipsis: true },
  { title: '单位', dataIndex: 'unit', key: 'unit', width: 70 },
  { title: '采购次数', dataIndex: 'lineCount', key: 'lineCount', width: 90, align: 'right' },
  { title: '涉及单据数', dataIndex: 'orderCount', key: 'orderCount', width: 100, align: 'right' },
  { title: '供应商数', dataIndex: 'supplierCount', key: 'supplierCount', width: 90, align: 'right' },
  { title: '采购数量', dataIndex: 'qty', key: 'qty', width: 110, align: 'right', render: qtyText },
  { title: '含税金额', dataIndex: 'amount', key: 'amount', width: 130, align: 'right', render: yuan },
  { title: '不含税金额', dataIndex: 'amountExTax', key: 'amountExTax', width: 130, align: 'right', render: yuan },
  { title: '加权均价(含税)', dataIndex: 'avgPrice', key: 'avgPrice', width: 130, align: 'right', render: priceText },
  { title: '最近采购价', dataIndex: 'lastPrice', key: 'lastPrice', width: 110, align: 'right', render: priceText },
  { title: '占总比', dataIndex: 'ratio', key: 'ratio', width: 90, align: 'right', render: percentText },
  { title: '首次采购日', dataIndex: 'firstDate', key: 'firstDate', width: 110 },
  { title: '最近采购日', dataIndex: 'lastDate', key: 'lastDate', width: 110 },
];

export const supplierColumns = [
  { title: '供应商编码', dataIndex: 'supplierNumber', key: 'supplierNumber', width: 110, fixed: 'left' },
  { title: '供应商名称', dataIndex: 'supplierName', key: 'supplierName', width: 260, ellipsis: true },
  { title: '采购单数', dataIndex: 'orderCount', key: 'orderCount', width: 100, align: 'right' },
  { title: '明细行数', dataIndex: 'lineCount', key: 'lineCount', width: 100, align: 'right' },
  { title: '物料种数', dataIndex: 'materialCount', key: 'materialCount', width: 100, align: 'right' },
  { title: '含税金额', dataIndex: 'amount', key: 'amount', width: 140, align: 'right', render: yuan },
  { title: '税额', dataIndex: 'taxAmount', key: 'taxAmount', width: 130, align: 'right', render: yuan },
  { title: '占总比', dataIndex: 'ratio', key: 'ratio', width: 90, align: 'right', render: percentText },
  { title: '首次采购日', dataIndex: 'firstDate', key: 'firstDate', width: 110 },
  { title: '最近采购日', dataIndex: 'lastDate', key: 'lastDate', width: 110 },
];

export const orderColumns = [
  { title: '单据编号', dataIndex: 'billNo', key: 'billNo', width: 130, fixed: 'left' },
  { title: '采购日期', dataIndex: 'billDate', key: 'billDate', width: 110 },
  { title: '采购部门', dataIndex: 'deptName', key: 'deptName', width: 110 },
  { title: '采购员', dataIndex: 'purchaserName', key: 'purchaserName', width: 100 },
  { title: '供应商编码', dataIndex: 'supplierNumber', key: 'supplierNumber', width: 110 },
  { title: '供应商名称', dataIndex: 'supplierName', key: 'supplierName', width: 240, ellipsis: true },
  { title: '明细行数', dataIndex: 'lineCount', key: 'lineCount', width: 90, align: 'right' },
  { title: '含税金额', dataIndex: 'totalAmount', key: 'totalAmount', width: 130, align: 'right', render: yuan },
];

export const orderLineColumns = [
  { title: '物料编码', dataIndex: 'materialNumber', key: 'materialNumber', width: 110 },
  { title: '物料名称', dataIndex: 'materialName', key: 'materialName', width: 200, ellipsis: true },
  { title: '数量', dataIndex: 'qty', key: 'qty', width: 100, align: 'right', render: qtyText },
  { title: '单位', dataIndex: 'unit', key: 'unit', width: 70 },
  { title: '不含税单价', dataIndex: 'price', key: 'price', width: 120, align: 'right', render: priceText },
  { title: '税率(%)', dataIndex: 'taxRate', key: 'taxRate', width: 80, align: 'right', render: v => (v === null || v === undefined ? '-' : Number(v).toFixed(2)) },
  { title: '含税单价', dataIndex: 'taxPrice', key: 'taxPrice', width: 120, align: 'right', render: priceText },
  { title: '税款', dataIndex: 'taxAmount', key: 'taxAmount', width: 110, align: 'right', render: yuan },
  { title: '价税合计', dataIndex: 'amount', key: 'amount', width: 120, align: 'right', render: yuan },
  { title: '交付日期', dataIndex: 'deliveryDate', key: 'deliveryDate', width: 110, render: v => v || '-' },
];

export const comparisonColumns = [
  { title: '供应商编码', dataIndex: 'supplierNumber', key: 'supplierNumber', width: 110, fixed: 'left' },
  { title: '供应商名称', dataIndex: 'supplierName', key: 'supplierName', width: 240, ellipsis: true },
  { title: '采购单数', dataIndex: 'orderCount', key: 'orderCount', width: 90, align: 'right' },
  { title: '采购数量', dataIndex: 'qty', key: 'qty', width: 110, align: 'right', render: qtyText },
  { title: '含税金额', dataIndex: 'amount', key: 'amount', width: 130, align: 'right', render: yuan },
  { title: '加权均价(含税)', dataIndex: 'avgPrice', key: 'avgPrice', width: 130, align: 'right', render: priceText },
  { title: '最近单价', dataIndex: 'lastPrice', key: 'lastPrice', width: 110, align: 'right', render: priceText },
  { title: '最低单价', dataIndex: 'minPrice', key: 'minPrice', width: 110, align: 'right', render: priceText },
  { title: '最高单价', dataIndex: 'maxPrice', key: 'maxPrice', width: 110, align: 'right', render: priceText },
  {
    title: '高于最低均价',
    dataIndex: 'diffVsMin',
    key: 'diffVsMin',
    width: 120,
    align: 'right',
    render: v => {
      if (v === null || v === undefined) return '-';
      if (v === 0) return <span style={{ color: '#3f8600' }}>最低</span>;
      return <span style={{ color: v > 10 ? '#cf1322' : '#d46b08' }}>+{Number(v).toFixed(2)}%</span>;
    },
  },
  { title: '首次采购日', dataIndex: 'firstDate', key: 'firstDate', width: 110 },
  { title: '最近采购日', dataIndex: 'lastDate', key: 'lastDate', width: 110 },
];
